<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const snippet = `
    <section class="p-4 md:p-5 xl:p-7 bg-lightest">
      <div class="container">
        <p class="copy">
          A section is a pattern for applying consistent responsive padding, wrapped around a container.
        </p>
      </div>
    </section>
    <section class="p-4 md:p-5 xl:p-7 bg-lighter">
      <div class="container">
        <p class="copy">
          It allows for full-width sections to have a background colour and break up a long page.
        </p>
      </div>
    </section>
    <section class="p-4 md:p-5 xl:p-7 bg-light">
      <div class="container">
        <p class="copy">
          This page is made up of sections with different background colors.
        </p>
      </div>
    </section>
  `;
</script>

<template>
  <section id="section" class="page-section bg-white">
    <div class="container">
      <h2 class="heading heading-2 my-6">Section</h2>
    </div>
    {@html snippet}
    <div class="container">
      <CodeSnippet id="section" {snippet} />
    </div>
  </section>
</template>
